module.exports = __webpack_public_path__ + "static/media/j.65fdbdb7.png";